// 要協助的那台電腦（主機頁、協助請求、紀錄都從主機清單組）與「這是手機嗎」（手機不能發起）。
import type { HostRow } from '../types';
import type { RemoteTarget } from './RemoteDialog';

export function targetOf(h: HostRow | undefined, fallback: { home_id: string; device_ref: string }, api: string): RemoteTarget {
  return {
    home_id: h?.home_id ?? fallback.home_id,
    device_ref: h?.target_ref ?? fallback.device_ref,
    api,
    hostname: h?.hostname,
    primary_user: h?.primary_user,
    console_user_admin: h?.console_user_admin,
    home_name: h?.home_name,
    org_name: h?.org_name,
  };
}

/** 手機（遠端工具只有 Windows / macOS / Linux；SPEC #kinio-kms-remote「App 不能發起：請在電腦上開始遠端協助」）。 */
export function isPhone(ua: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return /Android|iPhone|iPad|iPod/i.test(ua);
}
